<template>
  <div>
    <vxe-grid
      ref="xTable"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :height="disabled?tableHeight - 8:tableHeight - 60"
      size="small"
      border
      resizable
      row-id="detailCode"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span style="font-size: 14px; color: #606266">{{
              $l('INDEX.form_label_sample_information') || '样品信息'
            }}</span>
            <el-divider direction="vertical"></el-divider>
            <b-button
              class="mr-2"
              size="sm"
              v-if="!disabled"
              variant="outline-info"
              @click="openChooseStock()"
              >{{ $l('tips_select_out_sample') || '选择外借样品' }}
            </b-button>
            <b-button
              class="mr-2"
              size="sm"
              v-if="!disabled"
              variant="outline-info"
              @click="dialogVisible = true"
            >
              {{ $l('INDEX.scancode_addition') || '扫码添加' }}
            </b-button>
          </div>
        </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div v-if="!disabled">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
    <choose-sample-stock-dialog
      :visible.sync="chooseStockDialogVisible"
      :billType="billType"
      type="checkbox"
      @confirm="addData"
    />

    <EnterSampleBarcode
      :dialogVisible.sync="dialogVisible"
      :billType="billType"
      @confirm="addData"
    />
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import dayjs from '@/libs/util.date'
import EnterSampleBarcode from '@/views/backstage/components/enter-sampleBarcode/dialog.vue'
export default {
  mixins: [TableAutoHeight],
  components: {
    EnterSampleBarcode,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chooseStockDialogVisible: false,
      dialogVisible: false,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      billType: 'stockBatchReturn',
      stockBatchReturnCode: '',
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          width: 85,
          fixed: 'right',
          slots: {
            default: 'opt',
          },
        },
        {
          title: this.$l('INDEX.sample_barcode') || '样品条码',
          align: 'left',
          minWidth: '160',
          field: 'inputCode',
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.sample_style_no') || '样品款号',
          align: 'left',
          minWidth: '180',
          field: 'sampleStyleNo',
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.sample_name') || '样品名称',
          align: 'left',
          minWidth: '450',
          field: 'sampleName',
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.quantity') || '数量',
          align: 'left',
          minWidth: '80',
          field: 'inputNum',
        },
        {
          title: this.$l('form_label_linkBillNo') || '业务单号',
          align: 'left',
          minWidth: '140',
          field: 'linkBillNo',
        },
        {
          title: this.$l('form_label_batchType') || '业务类型',
          align: 'left',
          minWidth: '80',
          field: 'batchType',
        },
        {
          title: this.$l('form_label_borrow_date') || '业务日期',
          align: 'left',
          minWidth: '100',
          field: 'borrowDate',
        },
      ],
    }
  },
  watch: {},
  mounted() {},
  computed: {},
  activated() {},
  deactivated() {},
  methods: {
    // getHeight() {
    //   if (this.disabled) {
    //     this.tableHeight = window.innerHeight - 252
    //   } else {
    //     this.tableHeight = window.innerHeight - 300
    //   }
    // },

    load(val) {
      this.stockBatchReturnCode = val
    },
    openChooseStock() {
      this.chooseStockDialogVisible = true
    },
    addData(chooseData) {
      if (!chooseData) {
        return
      }
      chooseData.forEach((item) => {
        let batchType = item.modifyDescription === '样品销售' ? '回购' : '归还'
        let borrowDate = dayjs(item.modifyDate).format('YYYY-MM-DD')
        let singleRow = {
          detailCode: '',
          seqno: '',
          inputCode: item.sampleBarcode,
          sampleCode: item.sampleCode,
          inputNum: 1,
          price: 0,
          lendPrice: 0,
          subprice: 0,
          subLendPrice: 0,
          discount: 0,
          subAmount: 0,
          sampleStyleNo: item.sampleStyleNo,
          sampleName: item.sampleName,
          linkBillCode: item.modifyBillCode,
          linkBillNo: item.modifyBillNo,
          batchType: batchType,
          borrowDate: borrowDate,
        }
        let findCount = 0
        this.tableData.forEach((row) => {
          if (item.sampleBarcode === row.inputCode) {
            findCount++
          }
        })
        if (findCount === 0) {
          this.tableData.push(singleRow)
        }
      })
      this.$message.success(this.$l('INDEX.Added_successfully') || '添加成功')
    },
    delRow(row) {
      let index = this.$refs.xTable.getRowIndex(row)
      this.tableData.splice(index, 1)
    },
    //保存时需要
    getGoodsData() {
      return this.tableData
    },
  },
}
</script>
